// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"order-list"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M11 4H22M11 12H22M11 20H22","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M2 3H3C3.55228 3 4 3.4514 4 4.00368V10M4 10H2M4 10H6M2 14H5C5.55228 14 6 14.4477 6 15V16.5C6 17.0523 5.55228 17.5 5 17.5H3C2.44772 17.5 2 17.9477 2 18.5V21H6","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-order-list')
export default class OrderListIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'order-list',
    }
  }
}
